import { render, staticRenderFns } from "./product-item.vue?vue&type=template&id=013e5b72&scoped=true&"
import script from "./product-item.vue?vue&type=script&lang=js&"
export * from "./product-item.vue?vue&type=script&lang=js&"
import style0 from "./product-item.vue?vue&type=style&index=0&id=013e5b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013e5b72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013e5b72')) {
      api.createRecord('013e5b72', component.options)
    } else {
      api.reload('013e5b72', component.options)
    }
    module.hot.accept("./product-item.vue?vue&type=template&id=013e5b72&scoped=true&", function () {
      api.rerender('013e5b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/product-item.vue"
export default component.exports